import { render } from "./ForgeCompare.vue?vue&type=template&id=0ade7f9a&scoped=true&ts=true"
import script from "./ForgeCompare.vue?vue&type=script&lang=ts"
export * from "./ForgeCompare.vue?vue&type=script&lang=ts"

import "./ForgeCompare.vue?vue&type=style&index=0&id=0ade7f9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ade7f9a"]])

export default __exports__